import script from "./OrderComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderComplete.vue?vue&type=script&setup=true&lang=js"

import "./OrderComplete.vue?vue&type=style&index=0&id=40fd23da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40fd23da"]])

export default __exports__